import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MobilityIntroPageRoutingModule } from './mobility-intro-routing.module';

import { MobilityIntroPage } from './mobility-intro.page';
import { HeaderModule } from 'src/app/components/header/header.module';
import { IntroImageComponent } from 'src/app/components/intro-image/intro-image.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MobilityIntroPageRoutingModule,
    HeaderModule
  ],
  declarations: [MobilityIntroPage, IntroImageComponent]
})
export class MobilityIntroPageModule {}
